import React from "react";
import PropTypes from "prop-types";
import BlockGallery from "../ui/BlockGallery";

const BASE_URL = "https://www.saliorel.cloud";

/**
 * ModelBlock: props => React element
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * 3D Renderer
 *
 * @param {*} props
 */
const ModelBlock = props => (
  <div>
    {props.isReadOnlyMode ? (
      <iframe
        src={`${BASE_URL}/subcomps/3d/?model=${props.block.model}`}
        title="3D-Modell"
        width="100%"
        height="400"
        frameBorder="0"
      />
    ) : (
      <div>
        <BlockGallery
          {...props}
          options={[
            "aspirin",
            "caffeine",
            "cholesterol",
            "cu",
            "diamond",
            "glucose",
            "graphite",
            "nacl",
            "nicotine"
          ]}
          dataKey={"model"}
          prefix={"model.3d.molecule"}
        />
      </div>
    )}
  </div>
);

ModelBlock.propTypes = {
  /**
   * block: {url}
   * Contains the content block information
   */
  block: PropTypes.shape({
    model: PropTypes.string
  }).isRequired,

  /**
   * isReadOnlyMode: Boolean
   * True if the block is read-only
   */
  isReadOnlyMode: PropTypes.bool.isRequired,

  /**
   * onChange: updatedBlock => ()
   * Passes on a block update to the higher-level component
   */
  onChange: PropTypes.func.isRequired
};

export default ModelBlock;



// WEBPACK FOOTER //
// ./src/modules/editor/manuscript/blocks/3d/ModelBlock.js